module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedMedium.ff9f12a.ttf";